import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import GridItem from 'components/Grid/GridItem.js';

import styles from 'views/component/Styles.js';

import SimpleTable from 'views/component/SimpleTable.js';

const useStyles = makeStyles(styles);

export default function APSRouting(props) {
    const { factory, operationSelect, taskFilter, onSave } = props;
    const classes = useStyles();
    const [selectForm, setSelectForm] = useState({});

    useEffect(() => {
        setSelectForm(operationSelect);
    }, [operationSelect])

    const handleSave = function (tempData) {
        if (onSave) {
            onSave(tempData);
        }
    }
    return (
        <GridItem xs={12} md={4} className={classes.collapsed}>
            <div className={classes.cellTitle}>
                <h4>Routing</h4>
            </div>
            <div className={classes.cellContentAps}>
                <SimpleTable domain="aps" tableName="routing" params={factory} insertAttr={factory} droppable
                    selectForm={selectForm} selectFilter={{ oper_id: taskFilter }} onSave={handleSave} />
            </div>
        </GridItem>);
}